export default __webpack_public_path__ + "static/media/skovstykket-townhouse-6-rooms-09.22df8a92.jpg";